import { forwardRef } from 'react'
import { ImageProps } from './props'
import { StyledImage } from './styles'

const Image = forwardRef<HTMLImageElement, ImageProps>((props, ref) => (
    <StyledImage {...props} ref={ref} />
))

Image.displayName = 'Image'

export default Image

export { StyledImage }
